import { CreateNewCSVoucherForm } from './create-new-customer-service-voucher-form'

export const CreateNewCSVoucher = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <CreateNewCSVoucherForm onCloseModal={onCloseModal} />
}
